<template>

    <div>
        <div class="progress-circle"
             :class="{'over50': this.fixedPercent > 50}">
            <span>
            </span>
            <div class="left-half-clipper">
                <div class="first50-bar"
                     :style="colorFillOver50"
                ></div>
                <div class="value-bar"
                     :style="progress"></div>
            </div>
        </div>
    </div>

</template>

<script>

export default {

    name: 'circular-progress-bar',

    props: {

        percent: {
            type: Number,
            default: 0
        },

        size: {
            type: Number,
            default: 40
        },

        colorEmpty: {
            type: String,
            default: '#C8C8CF'
        },

        colorFill: {
            type: String,
            default: '#52BD89'
        }
    },

    computed: {

        progress() {
            return `transform: rotate(${this.fixedPercent * 3.6}deg);border-color: ${this.colorFill}`
        },

        colorFillOver50() {
            return this.fixedPercent > 50
                ? `background-color: ${this.colorFill};`
                : ''
        },

        fixedPercent() {
            if (this.percent > 99) {
                return 100
            } else if (this.percent < 1) {
                return 0
            } else {
                return this.percent
            }
        }
    }
}
</script>

<style lang="scss" scoped>

body,
html {
    font-size: 10px;
}

.progress-circle {
    font-size: 8px;
    margin: 8px;
    position: relative;
    padding: 0;
    width: 40px;
    height: 40px;
    background-color: #F2E9E1;
    border-radius: 50%;
    line-height: 40px;
}

.progress-circle:after {
    border: none;
    position: absolute;
    top: 3px;
    left: 3px;
    text-align: center;
    display: block;
    border-radius: 50%;
    width: 34px;
    height: 34px;
    content: " ";
    background-color: white;
}

.left-half-clipper {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    position: absolute;
    clip: rect(0, 40px, 40px, 20px);
}

.progress-circle.over50 .left-half-clipper {
    clip: rect(auto, auto, auto, auto);
}

.value-bar {
    position: absolute;
    clip: rect(0, 20px, 40px, 0);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 4px solid;
    box-sizing: border-box;
}

.progress-circle.over50 .first50-bar {
    position: absolute;
    clip: rect(0, 40px, 40px, 20px);
    border-radius: 50%;
    width: 40px;
    height: 40px;
}

.progress-circle:not(.over50) .first50-bar {
    display: none;
}

.progress-circle.p0 .value-bar {
    display: none;
}
</style>
